import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import BalancoService from '../../../../../services/balanco-auth';
import { Link, Navigate, useParams } from 'react-router-dom';



const FormTipo = () => {
    const [tipo, setTipo] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchBalanco(id) {
        const response = await BalancoService.balancoEdit(id);
        setTipo(response.data["tipo"]);
    }

    useEffect(() => {
        fetchBalanco(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const balanco = await BalancoService.editar(id, {
                tipo: tipo
            })
            if (balanco.data["cod_balanco"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col>
                                    <Form.Group className="mb-3" controlId="tipo">
                                        <FloatingLabel
                                            label="Tipo do Balanço"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="tipo"
                                                name="tipo"
                                                onChange={e => setTipo(e.target.value)}
                                            >
                                                <option value={tipo}>{tipo}</option>
                                                <option value="Financeiro">Financeiro</option>
                                                <option value="Orçamentário">Orçamentário</option>
                                                <option value="Patrimonial">Patrimonial</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/restrito/balanco/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Balanço editado com sucesso!</Alert>
                <Navigate to={'/restrito/balanco/listar'} />
            </Fragment>
        )
    }
}

export default FormTipo